import { api } from "api/api";
import { AxiosError } from "axios";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import OrdemProducao from "model/producao/OrdemProducao";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";
import { generateKey } from "utils/generateKey";

class OrdemProducaoService implements BaseServiceCadastros<OrdemProducao> {
    
    pesquisar(page: Pageable,  filters: DataTableFilterMeta) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/ordemProducao/pesquisar`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<OrdemProducao>((resolve, reject): void => {
            api
                .get(`/ordemProducao/consultar/${id}`)
                .then(response => {
                    const ordemProducao: OrdemProducao = response.data;

                    ordemProducao.componentesOp.forEach((componente) => {
                        componente.key = generateKey();
                        return componente;
                    });

                    resolve(ordemProducao);
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(ordemProducao: OrdemProducao) {
        return new Promise<OrdemProducao>((resolve, reject): void => {
            api
                .post(`/ordemProducao/incluir`, JSON.stringify(ordemProducao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(ordemProducao: OrdemProducao) {
        return new Promise<OrdemProducao>((resolve, reject): void => {
            api
                .put(`/ordemProducao/editar`, ordemProducao)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editarDataFimOP(ordemProducao: OrdemProducao) {
        return new Promise<OrdemProducao>((resolve, reject): void => {
            api
                .put(`/ordemProducao/editarDataFimOP`, ordemProducao)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/ordemProducao/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    liberar(id: number) {
        return new Promise<OrdemProducao>((resolve, reject): void => {
            api
                .put(`/ordemProducao/liberar/${id}`)
                .then(response => {
                    const ordemProducao: OrdemProducao = response.data;

                    ordemProducao.componentesOp.forEach((componente) => {
                        componente.key = generateKey();
                        return componente;
                    });

                    resolve(ordemProducao);
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    cancelar(id: number) {
        return new Promise<OrdemProducao>((resolve, reject): void => {
            api
                .put(`/ordemProducao/cancelar/${id}`)
                .then(response => {
                    const ordemProducao: OrdemProducao = response.data;

                    ordemProducao.componentesOp.forEach((componente) => {
                        componente.key = generateKey();
                        return componente;
                    });

                    resolve(ordemProducao);
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getListaStatus() {

        return [
            { label: "Gerada", value: "GERADA" },
            { label: "Liberada", value: "LIBERADA" },
            { label: "Em andamento", value: "EM_ANDAMENTO" },
            { label: "Finalizada", value: "FINALIZADA" },
            { label: "Cancelada", value: "CANCELADA" }
        ];
    }

    getStatus(status: string) {
        return this.getListaStatus().find(item => item.value === status)?.label || "";
    }

    getListaStatusFilter() {
        return [
            { label: "Gerada", value: "G" },
            { label: "Liberada", value: "L" },
            { label: "Em andamento", value: "A" },
            { label: "Finalizada", value: "F" },
            { label: "Cancelada", value: "C" }
        ]
    }
    getStatusFilter(status: string) {
        return this.getListaStatusFilter().find(item => item.value === status)?.label || "";
    }


    getListaStatusEstagio() {

        return [
            { label: "Gerado", value: "GERADO" },
            { label: "Liberado", value: "LIBERADO" },
            { label: "Em andamento", value: "EM_ANDAMENTO" },
            { label: "Finalizado", value: "FINALIZADO" }
        ];
    }

    getStatusEstagio(status: string) {
        return this.getListaStatusEstagio().find(item => item.value === status)?.label || "";
    }

    getProdutos() {
        return new Promise<Array<Produto>>((resolve, reject): void => {
            api
                .get(`/ordemProducao/produtos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getProdutosProduzidos() {
        return new Promise<Array<Produto>>((resolve, reject): void => {
            api
                .get(`/ordemProducao/produtosProduzidos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getClientes() {
        return new Promise<Array<Pessoa>>((resolve, reject): void => {
            api
                .get(`/ordemProducao/clientes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    
    getFasesQualidade(): any[] {
        return [
            { label: "Estágio", value: "ESTAGIO_PRODUCAO" },
            { label: "Produto acabado", value: "PRODUTO_ACABADO" }
        ];
    }

    getRelatorioEstagio(id: number) {

        return new Promise<string>((resolve, reject): void => {
            api
                .get(`/ordemProducao/report/estagio/${id}`, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });

    }

    getRelatorioCertificadoAnalise(idOp: number) {
        return new Promise<string>((resolve, reject): void => {
            api
                .get(`/ordemProducao/report/certificadoAnalise/${idOp}`, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });

    }

    getRelatorio(filters: DataTableFilterMeta) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/ordemProducao/report`;
            url += getFilters(filters);
            api
                .get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getRelatorioSimplificado(filters: DataTableFilterMeta) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/ordemProducao/report/simplificado`;
            url += getFilters(filters);
            api
                .get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default OrdemProducaoService;